import { Cable } from "lucide-react";
import { AdminPageHeader, AdminSectionCard } from "@/components/shell/AdminPage";

/** 品牌 MCP / 连接器占位（M0）：只读产品数据，与账户渠道分离 */
export default function BrandConnectorsPage() {
  return (
    <div className="space-y-6">
      <AdminPageHeader
        title="连接器(MCP)"
        description="只读接入产品数据，供旅程 AI 查询用量等。与账户「渠道」（怎么触达客户）分开。"
      />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <AdminSectionCard title="Baklib" description="只读 · 给旅程 AI 查用量">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <span className="inline-flex items-center gap-2 text-sm">
              <Cable className="size-4" />
              <span className="rounded-md bg-muted px-2 py-0.5 text-xs font-medium text-muted-foreground">
                未接
              </span>
            </span>
            <p className="text-xs text-muted-foreground">本期仅占位，暂无配置入口</p>
          </div>
        </AdminSectionCard>
      </div>
    </div>
  );
}
